<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <page-main
      ref="main"
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      @reload="reload"
      @checkCompleted="checkCompleted"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @batchSumit="batchSumit"
        @batchExport="batchExport"
        @batchCompleted="batchCompleted"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'

export default {
  components: {
    PageMain,
    PageHeader,
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      fullScreenLoading: false,
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .carriageWaybillDetailListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    checkCompleted(listCode) {
      this.fullScreenLoading = true
      this.$api
        .carriageWaybillDetailIsFinshApi({listCode: listCode})
        .then((res) => {
          this.fullScreenLoading = false
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$refs.main.clearCheckboxRow()
          this.reload()
        })
        .catch(() => {
          this.fullScreenLoading = false
        })
    },
    batchSumit() {
      this.$refs.main.batchSumit()
    },
    batchExport() {
      this.$refs.main.batchExport()
    },
    batchCompleted(){
      this.$refs.main.batchCompleted()
    }
  },
}
</script>
